<template>
  <div
    :class="[
      'mt-auto d-flex',
      {
        'gap-16 justify-center flex-column mt-0': isMinimized && !isMain,
        'align-center': isMain,
        'flex-column gap-4': isCompact
      }
    ]"
  >
    <c-sheet
      v-for="messenger in managerMessengers"
      :key="messenger.id"
      :class="[
        {
          'mr-3': isMain,
          'bg-black': isCompact
        }
      ]"
    >
      <v-hover v-slot="{ isHovering, props: hoverProps }">
        <a
          v-bind="hoverProps"
          :class="[
            'text-decoration-none d-flex',
            isMinimized ? 'justify-center' : 'justify-space-between',
            {
              'pa-2': isCompact
            }
          ]"
          :href="messenger.url"
          target="_blank"
        >
          <v-icon
            :size="isMain ? 24 : 20"
            :class="[isCompact ? 'text-white' : 'text-primary']"
          >
            {{ messenger.icon }}
          </v-icon>
          <template v-if="!isMinimized">
            <span
              :class="[
                isCompact
                  ? 'text-white text-caption ml-2'
                  : 'text-body-2 font-weight-medium text-decoration-underline mx-1'
              ]"
            >
              {{ messenger.name }}
            </span>

            <v-icon
              size="20"
              :class="['ml-auto', isHovering ? 'text-white' : 'text-secondary-400']"
            >
              $arrow-right-top
            </v-icon>
          </template>
        </a>
      </v-hover>
    </c-sheet>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'pinia'
  import { useCollectionsStore } from '@/store/collections/collections'
  import { CSheet } from '@clickadilla/components/components'

  export default {
    name: 'ManagerContacts',
    components: { CSheet },
    props: {
      isMinimized: {
        type: Boolean,
        default: false
      },
      isCompact: {
        type: Boolean,
        default: false
      },
      isMain: {
        type: Boolean,
        default: false
      },
      managerInfo: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        messengersMaxCount: 2
      }
    },
    computed: {
      ...mapState(useCollectionsStore, ['messengers']),
      messengerIconsByName() {
        return {
          Teams: '$teams-outlined',
          Telegram: '$telegram',
          Wechat: '$wechat',
          Whatsapp: '$whatsapp',
          Facebook: '$facebook-outlined',
          Line: '$line',
          QQ: '$qq',
          Email: '$mail',
          Message: '$mail-send'
        }
      },
      managerMessengers() {
        return (
          this.managerInfo.messengers
            ?.slice(0, this.messengersMaxCount)
            .map((adminMessenger) => {
              const messengerResource = this.messengers.find(
                ({ id }) => id === adminMessenger.id
              )
              if (!messengerResource) return []

              const messengerIcon = this.messengerIconsByName[messengerResource.name]
                ?? this.messengerIconsByName.Message
              return {
                id: adminMessenger.id,
                name: messengerResource.name,
                url: adminMessenger.nickname,
                icon: messengerIcon
              }
            }) ?? []
        )
      }
    },
    async created() {
      await this.fetchMessengersList()
    },
    methods: {
      ...mapActions(useCollectionsStore, ['fetchMessengersList'])
    }
  }
</script>

<style scoped lang="scss">
.gap-16 {
  gap: 16px;
}
.gap-4 {
  gap: 4px;
}
</style>
